import type { NextPage } from 'next'

import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const CarbonCalculatorPage: NextPage = () => (
  <SanityContentPage slug='native-trees-carbon-calculator' />
)

export default CarbonCalculatorPage
